const vapidKeys: { [lob: string]: string } = {
  'default': 'BNYgv27V6c11urVEMYJbU3C9jGL4dchKghcN9COm_2SbydQDD9Lr_TnAAW-m0mm7VCowtdECHfPFxxxmTtgNZAM',
  'ckcoeuat': 'BN7HG0gqXu-XliCLM3BtDaPnU39pMb-vA-_cTnBbOZwiQzFWF73nayzSDWcHnFSyv6flkss_h57-uu6Lli9eNQQ',
  'ckcoedemo': 'BBd3rryioqyvhBK5bGC0yfyc9MQJeG_JFdznapS86L2skaQpS8DaZBvX2WQGgRBontMcUEhkTMfimKlcNCfXYSg',
  'ckcoe': 'BLfar5XaSwxKYnjaJkCZ-Y8wW0aJP2rDp7XFI0QNVRBu4T1VAGewwoaOpPmNuhlmb0uTI45TMSGlHtJjOpvBvcM',
};


export function getVapidKey(lob: string): string {
  // Normalize LOB identifier
  const normalizedLob = lob?.toLowerCase().trim() || 'default';
  
  // Get VAPID key for the LOB, fallback to default
  const vapidKey = vapidKeys[normalizedLob] || vapidKeys['default'];
  
  if (!vapidKey) {
    console.error(`VAPID key not found for LOB: ${normalizedLob}`);
    throw new Error('VAPID key not available');
  }
  
  return vapidKey;
}

export function isVapidKeyConfigured(lob: string): boolean {
  const normalizedLob = lob?.toLowerCase().trim();
  const vapidKey = vapidKeys[normalizedLob];
  
  if (!vapidKey) {
    return false;
  }
  
  return !(vapidKey.includes('YOUR_') && vapidKey.includes('_VAPID_KEY_HERE'));
}
